export default {
  tag: {
    type: String,
    default: 'div'
  },
  inline: Boolean,
  flex: Boolean,
  column: Boolean,
  wrap: Boolean,
  relative: Boolean,
  scroll: Boolean,
  overflow: {
    default: true,
    type: Boolean
  },
  scrollX: Boolean,
  scrollY: Boolean,
  scrollLeft: Number,
  scrollTop: Number,
  scrollIntoView: String,
  upperThreshold: {
    type: Number,
    default: 20
  },
  lowerThreshold: {
    type: Number,
    default: 20
  },
  w: [Number, String],
  h: [Number, String],
  pa: [Number, String],
  ph: [Number, String],
  pv: [Number, String],
  pt: [Number, String],
  pb: [Number, String],
  pl: [Number, String],
  pr: [Number, String],
  ma: [Number, String],
  mh: [Number, String],
  mv: [Number, String],
  mt: [Number, String],
  mb: [Number, String],
  ml: [Number, String],
  mr: [Number, String],
  bg: String
}



// WEBPACK FOOTER //
// ./src/components/Container/_props.js